/* istanbul ignore file */
import DOMPurify from 'dompurify';
import validator from 'validator';

export const URL_OPTIONS = {
  allow_trailing_dot: true,
  allow_underscores: false,
  protocols: ['http', 'https'],
  require_protocol: false,
  require_valid_protocol: true
};

/**
 * Validate if a string is Base64-encoded
 *
 * @see {@link https://github.com/validatorjs/validator.js/blob/master/src/lib/isBase64.js Docs}
 * @param {string} str - The string to validate
 * @returns {boolean} True if the string is Base64-encoded, false otherwise
 */
export function isBase64(str) {
  return validator.isBase64(str);
}

/**
 * Validate if a string is a valid URL
 *
 * @see {@link https://github.com/validatorjs/validator.js/blob/master/src/lib/isURL.js Docs}
 * @param {string} str - The string to validate
 * @param {object} options - The options to pass to the validator
 * @returns {boolean} True if the string is a valid URL, false otherwise
 */
export function isURL(str, options = URL_OPTIONS) {
  return validator.isURL(str, options);
}

/**
 * Validate if a string is a valid UUID
 *
 * @see {@link https://github.com/validatorjs/validator.js/blob/master/src/lib/isUUID.js Docs}
 * @param {string} str - The string to validate
 * @returns {boolean} True if the string is a valid UUID, false otherwise
 */
export function isUUID(str) {
  return validator.isUUID(str);
}

/**
 * Sanitize a string using DOMPurify
 *
 * @see {@link https://github.com/cure53/DOMPurify Docs}
 * @param {string} data - The string to sanitize
 * @returns {string} The sanitized string
 */
export function sanitize(data) {
  return DOMPurify.sanitize(data);
}
